// Configuration de l'API
export const API_CONFIG = {
  baseURL: process.env.VUE_APP_API_URL || 'https://backend.coop-finance-app.wixoon.dev/api',
  //baseURL: 'http://localhost:8000/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
}

// Stockage du token
export const TokenStorage = {
  getToken(): string | null {
    return localStorage.getItem('auth_token')
  },

  setToken(token: string): void {
    localStorage.setItem('auth_token', token)
  },

  removeToken(): void {
    localStorage.removeItem('auth_token')
  },

  getUser(): any {
    const user = localStorage.getItem('user_data')
    return user ? JSON.parse(user) : null
  },

  setUser(userData: any): void {
    localStorage.setItem('user_data', JSON.stringify(userData))
  },

  removeUser(): void {
    localStorage.removeItem('user_data')
  },

  clear(): void {
    this.removeToken()
    this.removeUser()
    console.log('[TokenStorage] 🗑️ Stockage nettoyé')
  }
}

// Intercepteur pour ajouter le token aux requêtes
export function getAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = { ...API_CONFIG.headers }
  const token = TokenStorage.getToken()
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
    // Log seulement si le token n'est pas présent (pour le debug)
    // console.log('[getAuthHeaders] 🔑 Token ajouté aux headers')
  } else {
    console.warn('[getAuthHeaders] ⚠️ Aucun token disponible - Les requêtes échoueront probablement')
  }
  
  return headers
}

// Vérifier si l'utilisateur est authentifié
export function isAuthenticated(): boolean {
  const token = TokenStorage.getToken()
  const user = TokenStorage.getUser()
  
  const authenticated = !!(token && user)
  
  // Log seulement si non authentifié pour le debug
  if (!authenticated) {
    console.warn('[isAuthenticated] ⚠️ Utilisateur non authentifié:', {
      hasToken: !!token,
      hasUser: !!user
    })
  }
  
  return authenticated
}

// Gestion des erreurs API
export interface ApiResponse<T = any> {
  status: number
  title?: string
  message: string
  data?: T
  token?: string
}

export function handleApiError(error: any): ApiResponse {
  // Si l'erreur a déjà été formatée par l'intercepteur axios (comme dans le backoffice)
  let errorMessage = 'Une erreur est survenue'
  
  if (error.message && typeof error.message === 'string') {
    errorMessage = error.message
  } else if (error.response) {
    // Erreur de réponse du serveur
    errorMessage = error.response.data?.message || 'Une erreur est survenue lors de la requête au serveur'
  } else if (error.request) {
    // Pas de réponse du serveur
    errorMessage = 'Impossible de contacter le serveur. Vérifiez votre connexion internet.'
  } else {
    // Erreur lors de la configuration de la requête
    errorMessage = error.message || 'Une erreur inattendue est survenue'
  }
  
    return {
    status: error.response?.status || error.httpstatuscode || 3,
    title: error.response?.data?.title || 'Erreur',
    message: errorMessage,
    data: error.response?.data?.data || null
  }
}

// Fonction utilitaire pour obtenir uniquement le message d'erreur (pour compatibilité avec le backoffice)
export function getErrorMessage(error: any): string {
  const apiError = handleApiError(error)
  return apiError.message
}

//
export const BACKEND_URL = process.env.VUE_APP_BACKEND_URL || 'https://backend.coop-finance-app.wixoon.dev';